export default "__VITE_ASSET__B8K$OMHZ__"